import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Button } from '../button';
import { IconID } from '../icon';
import { Typography } from '../typography';
import styles from './explainer-card.module.scss';
export const ExplainerCard = ({ title, description, media, tertiaryButton, primaryButton, crossButtonRef, isCrossButton = true, className = '', onCrossClick = _.noop, }) => {
    const { t } = useTranslation();
    const renderTitle = () => {
        const titleWrapperClasses = cx(styles.title, {
            [styles.titleMaxWidth]: isCrossButton,
        });
        return (React.createElement("div", { className: titleWrapperClasses },
            React.createElement(Typography, { variant: "h4", ellipsis: { rows: 2 } }, title)));
    };
    const renderDescription = () => {
        const descriptionWrapperClasses = cx(styles.description, {
            [styles.descriptionMaxWidth]: !title && isCrossButton,
        });
        return (React.createElement("div", { className: descriptionWrapperClasses },
            React.createElement(Typography, { variant: "body-normal" }, description)));
    };
    return (React.createElement("div", { className: cx(styles.card, className) },
        title && renderTitle(),
        isCrossButton && (React.createElement(Button, { size: "s", icon: IconID.CROSS, type: "tertiary", onClick: onCrossClick, className: styles.crossBtn, ariaLabel: t('CLOSE'), buttonRef: crossButtonRef })),
        React.createElement("div", { className: styles.cardContent },
            description && renderDescription(),
            media && React.createElement("div", { className: styles.mediaWrapper }, media),
            (tertiaryButton || primaryButton) && (React.createElement("div", { className: styles.btnWrapper },
                tertiaryButton && (React.createElement(Button, { className: styles.actionBtn, type: "tertiary", onClick: tertiaryButton.onClick, size: "s", text: tertiaryButton.label, isDisabled: tertiaryButton.isDisabled })),
                primaryButton && (React.createElement(Button, { className: styles.actionBtn, type: "primary", onClick: primaryButton.onClick, size: "s", text: primaryButton.label, isDisabled: primaryButton.isDisabled })))))));
};
//# sourceMappingURL=explainer-card.js.map